/** Saves all UTM-parameters to a cookie **/
jQuery(document).ready(function ($) {
  const utmParams = getUtmParams();
  if (Object.keys(utmParams).length > 0) {
    const utmParamsString = JSON.stringify(utmParams);
    setCookie("utmParams", utmParamsString, 7); // Cookie expires in 7 days
  }

  function getUtmParams() {
    const params = new URLSearchParams(window.location.search);
    const result = {};

    params.forEach((value, key) => {
      if (key.startsWith("utm_")) {
        result[key] = value;
      }
    });

    return result;
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000)); // Set expiration time
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/`;
  }
});
